import { useState, useEffect } from "react";
import { usePost } from "./API";
import { useLocalizedStrings } from "./Localization";
import { SpacedSpinner } from "./Util";

export function VirtualCardSetup() {
  const params = new URLSearchParams(window.location.search);
  const L = useLocalizedStrings();

  const checkStatus = usePost('/card/details');
  const activate = usePost('/usio/activate_virtual');

  const [pin, setPin] = useState('');
  const [pinAgain, setPinAgain] = useState('');

  const validClass = "max-w-lg block w-full shadow-sm border-solid p-2 mt-1 mb-1 sm:max-w-xs sm:text-sm rounded-md border-2 border-green-200 focus:ring-green-400 ring-green-400 focus:border-green-400";
  const invalidClass = "max-w-lg block w-full shadow-sm border-solid p-2 mt-1 mb-1 sm:max-w-xs sm:text-sm rounded-md border-2 border-red-200 focus:ring-red-400 ring-red-400 focus:border-red-400";

  useEffect(() => {
    (async () => {
      const status = await checkStatus({});
      console.log(status);
      if ((status as any).value) { // (status as any).value.status.status === 'Active') {
        window.location.href = (status as any).value.redirect!;
      } else {
        const status = await activate({
          pin: ''
        });
        if ((status as any).value) {
          window.location.href = (status as any).value.redirect!;
        }
      }
    })()
  }, []);

  return <>
    <h1 className="text-center">Activating your card</h1>
    <div className="text-center"><SpacedSpinner /></div>
    <div className="hidden">
      <fieldset>
        <legend>PIN</legend>
        <input type='password' value={pin} onChange={(e) => { const value = (e.target.value || '').replace(/[^0-9]/g, '').slice(0, 4); setPin(value); }}
          className={pin.match(/[0-9]{4}/) ? validClass : invalidClass} />
      </fieldset>
      <fieldset>
        <legend>PIN Again</legend>
        <input type='password' value={pinAgain} onChange={(e) => { const value = (e.target.value || '').replace(/[^0-9]/g, '').slice(0, 4); setPinAgain(value); }}
          className={pinAgain.match(/[0-9]{4}/) && pin === pinAgain ? validClass : invalidClass} />
        {pinAgain.match(/[0-9]{4}/) && pin !== pinAgain && <div className="text-red-500">PINs do not match</div>}
      </fieldset>
    </div>
  </>;
}
